import { InMemoryCache } from "@apollo/client";
import { venuePortalUserPolicies } from "./policies/venuePortalUserPolicies";

export const cache = new InMemoryCache({
  typePolicies: {
    ...venuePortalUserPolicies,
  },
});
